// Theme colors from fazenda-front
export const COLORS = {
  // Primary colors
  EDEN: '#0C5240',
  GREEN_PEA: '#195142',
  ZUCCINI: '#064E3B',
  
  // Secondary colors
  APPLE: '#6BC43C',
  NEBULA: '#CDDBD7',
  EDEN_ALPHA: '#0f4f3f',
  
  // Success colors
  OPAL: '#B4CAC4',
  
  // Warning colors
  ORANGE: '#FF8C00',
  ORANGE_LIGHT: '#FFB347',
  
  // Background colors
  GHOST_WHITE: '#F6F9FB',
  WHITE: '#FFFFFF',
  
  // Text colors
  MIRAGE: '#1E293B',
  SHUTTLE_GRAY: '#515F71',
  
  // Gray scale
  CATSKILL_WHITE: '#F1F5F9',
  CATSKILL_WHITE_BETA: '#E2E8F0',
  BRIGHT_GRAY: '#E5EBF0',
  SLATE_GRAY: '#6B7B90',
  OXFORD_BLUE: '#2E3849',
  
  // Additional colors
  SUCCESS: '#6BC43C',
  ERROR: '#FF5722',
  WHATSAPP: '#25D366',
} as const;

// Input suggestions
export const INPUT_SUGGESTIONS = [
  "Como está a vaca #127?",
  "Registre vacinação do lote A",
  "Mostrar histórico de reprodução",
  "Localizar animal perdido",
  "Agendar próxima inseminação",
  "Relatório mensal do rebanho"
] as const;

// Form validation
export const VALIDATION = {
  MAX_MESSAGE_LENGTH: 500,
  MIN_MESSAGE_LENGTH: 5,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
} as const;

// Animation durations
export const ANIMATION = {
  FADE_IN: 800,
  SLIDE_UP: 1000,
  ZOOM_IN: 1200,
  STAGGER_DELAY: 200,
  SUGGESTION_ROTATION: 3000,
  USER_COUNT_UPDATE: 30000,
  URGENCY_UPDATE: 45000,
} as const;

// Progress tracking
export const PROGRESS = {
  MESSAGE_START: 30,
  MESSAGE_MEDIUM: 20,
  MESSAGE_LONG: 30,
  COMPLETION: 100,
} as const;

// Breakpoints
export const BREAKPOINTS = {
  MOBILE: 480,
  TABLET: 768,
  DESKTOP: 1024,
  LARGE: 1200,
} as const;

// API endpoints (for future use)
export const API_ENDPOINTS = {
  CHAT: '/api/chat',
  EMAIL_SIGNUP: '/api/email-signup',
  ANALYTICS: '/api/analytics',
} as const;

// Local storage keys
export const STORAGE_KEYS = {
  USER_SESSION: 'muu_user_session',
  CHAT_HISTORY: 'muu_chat_history',
  PREFERENCES: 'muu_preferences',
  ONBOARDING_COMPLETED: 'muu_onboarding_completed',
  // Authentication keys
  ACCESS_TOKEN: 'muu_access_token',
  REFRESH_TOKEN: 'muu_refresh_token',
  AUTH_STATE: 'muu_auth_state',
  LAST_ACTIVITY: 'muu_last_activity',
} as const;

// Authentication Constants
export const AUTH = {
  TOKEN_PREFIX: 'Bearer',
  REFRESH_THRESHOLD: 5 * 60 * 1000, // 5 minutes
  SESSION_TIMEOUT: 30 * 60 * 1000, // 30 minutes
  MAX_LOGIN_ATTEMPTS: 5,
  LOCKOUT_DURATION: 15 * 60 * 1000, // 15 minutes
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
} as const;

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  USER: 'user',
  PROFESSIONAL: 'professional',
  GUEST: 'guest',
} as const;

// Permissions
export const PERMISSIONS = {
  // Admin permissions
  ADMIN_ALL: 'admin:all',
  
  // User permissions
  USER_READ: 'user:read',
  USER_WRITE: 'user:write',
  USER_DELETE: 'user:delete',
  
  // Farm permissions
  FARM_READ: 'farm:read',
  FARM_WRITE: 'farm:write',
  FARM_DELETE: 'farm:delete',
  
  // Professional permissions
  PROFESSIONAL_ALL: 'professional:all',
  APPOINTMENT_ALL: 'appointment:all',
} as const;

// Social links
export const SOCIAL_LINKS = {
  WHATSAPP: 'https://wa.me/5511999999999',
  INSTAGRAM: 'https://instagram.com/muu_app',
  LINKEDIN: 'https://linkedin.com/company/muu-app',
} as const;

// Trust signals data
export const TRUST_SIGNALS = {
  INITIAL_USER_COUNT: 847,
  INITIAL_URGENCY_COUNT: 47,
  MIN_URGENCY_COUNT: 20,
} as const;